import React, { Component } from 'react';
import PropTypes from 'prop-types';


import DateTime from "components/Display/ViewDateTime";
import ClaimState from "../Display/ClaimState";
import RecordAction from "../Display/RecordAction";

const RecordErrorTable = ({ list }) => {
  if (!list){
    return (
      <div/>
    );
  }

  return (
    <div className="calc-setting-table ">
      <table className="table">
        <colgroup>
          <col />
          <col />
          <col />
          <col />
        </colgroup>
        <thead>
        <tr>
          <th colSpan="4" className="text-left calc-setting-table-header">Villur</th>
        </tr>
        <tr>
          <th className="text-left">ErrorID</th>
          <th className="text-left">ErrorNo</th>
          <th className="text-left">Field</th>
          <th className="text-left">Message</th>
        </tr>
        </thead>
        <tbody>
        {list.map(function(item,i){
          return(
            <tr key={i}>
              <td className="text-left">{item.recordErrorID.toString()} </td>
              <td className="text-left">{item.errorNumber.toString()}</td>
              <td className="text-left">{item.field}</td>
              <td className="text-left">{item.errorMessage}</td>
            </tr>);
        })}
        </tbody>
      </table>
    </div>
  );
};

RecordErrorTable.propTypes = {
  list: PropTypes.array
};

export default RecordErrorTable;




// WEBPACK FOOTER //
// ./src/pages/ClaimTracker/Batch/RecordErrorTable.js